<div class="az-sidebar sidebar-inner-content">
  <div class="sidebar-inner-content">
    <p-table #dt1 id="azHeader" [scrollable]="true" [lazy]="false" dataKey="azKey">
      <ng-template pTemplate="caption">
        <div class="flex search-header">
          <span class="p-input-icon-left col-12">
            <input #searchInput class="header-search" pInputText type="text" (input)="filter(dt1, $event)"
                   placeholder="Search by provider, zone, building or ID"/>
          </span>
        </div>
      </ng-template>
    </p-table>
    @defer (on viewport) {
      <div class="az-layers">
        <cdk-virtual-scroll-viewport itemSize="50" class="virtual-scroll-viewport">
          <div *cdkVirtualFor="let item of flatItems; let i = index" class="virtual-item">
            
            <!-- Group Header -->
            <div *ngIf="item.type === 'group'" class="az-group-header">
              <span class="group-title">{{ item.azId }}</span>
            </div>
            
            <!-- Layer Item -->
            <div *ngIf="item.type === 'layer'" class="az-layer">
              <div class="layer-header">
                <div class="layer-info">
                  <p-colorPicker
                    [appendTo]="'body'"
                    [(ngModel)]="item.layer!.color"
                    (onHide)="onHideColorPicker()"
                    (onChange)="onColorChanged($event, item.layer!)">
                  </p-colorPicker>
                  <span class="layer-name">{{ item.layer!.building }}</span>
                </div>
                <a (click)="toggleAZVisibility(item.layer!)"
                   style="cursor: pointer; text-decoration: none; margin-top: 3px"
                   [class]="item.layer!.isVisible ? 'pi pi-eye' : 'pi pi-eye-slash'">
                </a>
              </div>
            </div>
            
          </div>
        </cdk-virtual-scroll-viewport>
      </div>
    } @placeholder {
      <div style="text-align: center;margin-top: 10px; margin-bottom: 10px">
        <p-progress-spinner
          strokeWidth="8"
          fill="transparent"
          animationDuration=".5s"
          [style]="{ width: '20px', height: '20px' }"
        />
      </div>
    }

  </div>
</div>
